module.exports = __webpack_public_path__ + "static/media/logo.72b5293a.svg";